import { Card, CardContent, Divider, Grid, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { Dispatch, Fragment, SetStateAction, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../css/HistoryOrderList.scss";
import { OrderItemList } from "../OrderItemList";
import { HandleErrorAndLoading } from "@common/HandleErrorAndLoading/HandleErrorAndLoading";
import { MONTH_INTERVAL_LIST } from "../utils";
import { IOrder } from "../interface/IOrder";
import { IFetchState } from "itsf-ui-common";

interface IParams {
    getHistoryOrderList(): void;
    historyOrderList: IOrder[];
    historyOrderListState: IFetchState;
    selectedMonth: number;
    setSelectedMonth: Dispatch<SetStateAction<number>>;
}

export const HistoryOrderList = (props: IParams) => {
    const { getHistoryOrderList, historyOrderList, historyOrderListState, selectedMonth, setSelectedMonth } = props;
    const { t } = useTranslation(["order", "glossary"]);

    useEffect(() => {
        getHistoryOrderList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedMonth]);

    return (
        <Fragment>
            <Grid className="historyOrder-header" container spacing={2}>
                <Grid item>
                    <InputLabel htmlFor="history-helper">
                        <Typography color="primary" variant="h2">
                            {t("order:myOrderHistory")}
                        </Typography>
                    </InputLabel>
                </Grid>
                <Grid item>
                    <Select
                        aria-label="Select filter"
                        disableUnderline
                        fullWidth
                        id="history-helper"
                        value={selectedMonth}
                        variant="filled"
                        onChange={(event) => setSelectedMonth(parseInt(event.target.value as string))}
                    >
                        {MONTH_INTERVAL_LIST.map((month) => (
                            <MenuItem key={month} value={month}>
                                {t("glossary:lastXMonths", { monthsNumber: month })}
                            </MenuItem>
                        ))}
                    </Select>
                </Grid>
            </Grid>
            <HandleErrorAndLoading isLoading={historyOrderListState.isLoading}>
                <Card elevation={2}>
                    <CardContent>
                        {historyOrderList.length > 0 ? (
                            <Stack spacing={3}>
                                {historyOrderList.map((order, index) => (
                                    <Fragment key={order.reference}>
                                        <OrderItemList offerList={order.offers} order={order} />
                                        {historyOrderList.length !== index + 1 && <Divider variant="fullWidth" />}
                                    </Fragment>
                                ))}
                            </Stack>
                        ) : (
                            <Typography align="center" color="textSecondary" variant="normal">
                                {t("order:noOrdersPeriod")}
                            </Typography>
                        )}
                    </CardContent>
                </Card>
            </HandleErrorAndLoading>
        </Fragment>
    );
};
